/* np-search.js — lightweight predictive search for .nph-search */
(function () {
  'use strict';

  function init() {
    var forms = document.querySelectorAll('.nph-search');
    forms.forEach(function (form) {
      var inp = form.querySelector('input[type="search"], input[name="q"]');
      if (!inp || inp._npSearch) return;
      inp._npSearch = true;

      var box = document.createElement('div');
      box.className = 'nph-suggest';
      box.hidden = true;
      box.setAttribute('role', 'listbox');
      form.appendChild(box);

      var timer, active = -1;

      function hide() { box.hidden = true; active = -1; }
      function show() { box.hidden = false; }

      function render(products, collections, q) {
        var html = '';
        collections.slice(0, 2).forEach(function (c) {
          html += '<a class="nph-sug-coll" href="' + c.url + '" role="option">' + c.title + '</a>';
        });
        products.slice(0, 6).forEach(function (p) {
          var img = p.featured_image
            ? '<img class="nph-sug-img" src="' + p.featured_image + '&width=80" alt="" width="38" height="46" loading="lazy">'
            : '<span class="nph-sug-nopic"></span>';
          var price = p.price ? '<span class="nph-sug-price">' + Shopify.formatMoney(p.price, window.theme_currency_format || '{{amount}}') + '</span>' : '';
          html += '<a class="nph-sug-item" href="' + p.url + '" role="option">' + img + '<span class="nph-sug-text"><span class="nph-sug-title">' + p.title + '</span>' + price + '</span></a>';
        });
        if (products.length === 0 && collections.length === 0) {
          html = '<a class="nph-sug-all" href="/search?q=' + encodeURIComponent(q) + '">Search for &ldquo;' + q + '&rdquo;</a>';
        } else {
          html += '<a class="nph-sug-all" href="/search?q=' + encodeURIComponent(q) + '">See all results</a>';
        }
        box.innerHTML = html;
        show();
        active = -1;
      }

      inp.addEventListener('input', function () {
        clearTimeout(timer);
        var q = inp.value.trim();
        if (q.length < 2) { hide(); return; }
        timer = setTimeout(function () {
          fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product,collection&resources[limit]=8')
            .then(function (r) { return r.ok ? r.json() : null; })
            .then(function (data) {
              if (!data || inp.value.trim() !== q) return;
              var res = data.resources && data.resources.results || {};
              render(res.products || [], res.collections || [], q);
            })
            .catch(function () {});
        }, 180);
      });

      /* keyboard: up/down/escape/enter */
      inp.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { hide(); return; }
        var items = box.querySelectorAll('.nph-sug-item, .nph-sug-coll, .nph-sug-all');
        if (!items.length) return;
        if (e.key === 'ArrowDown') {
          e.preventDefault();
          items.forEach(function (x) { x.classList.remove('is-selected'); });
          active = Math.min(active + 1, items.length - 1);
          items[active].classList.add('is-selected');
        } else if (e.key === 'ArrowUp') {
          e.preventDefault();
          items.forEach(function (x) { x.classList.remove('is-selected'); });
          active = Math.max(active - 1, 0);
          items[active].classList.add('is-selected');
        } else if (e.key === 'Enter' && active >= 0) {
          e.preventDefault();
          items[active].click();
        }
      });

      /* click outside */
      document.addEventListener('click', function (e) {
        if (!form.contains(e.target)) hide();
      });

      inp.addEventListener('focus', function () {
        if (box.innerHTML && !box.hidden) show();
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();